import React from 'react';

import {
  Celebration,
  Chrome,
  Coffee,
  Confetti,
  Cookie,
  Fire,
  GuideHeart,
  HeartFace,
  Honey,
  MenuChrome,
  MenuNaver,
  MenuSafari,
  MenuSamsung,
  Moon,
  Note,
  NewsletterGuideIcon,
  Ok,
  PlayfulFace,
  Rocket,
  SearchFace,
  SecretFace,
  Slack,
  SmileFace,
  Sprout,
  Sun,
  ThinkFace,
  Verification,
  IncreaseTriangle,
  DecreaseTriangle,
  By,
  Eye,
  Heart,
  Scrap,
  Collection,
  Highlight,
  Arlam,
  FlyingRocket,
  NewsletterProfile,
} from './parts';

export type IconName = (typeof IconNames)[number];

const IconNames = [
  'fire',
  'rocket',
  'heart_face',
  'slack',
  'verification',
  'think_face',
  'confetti',
  'cookie',
  'moon',
  'sun',
  'secret_face',
  'ok',
  'chrome',
  'search_face',
  'menu_naver',
  'menu_samsung',
  'menu_chrome',
  'menu_safari',
  'playful_face',
  'newsletter_guide_icon',
  'smile_face',
  'celebration',
  'coffee',
  'honey',
  'sprout',
  'guide_heart',
  'increase_triangle',
  'decrease_triangle',
  'by',
  'eye',
  'heart',
  'note',
  'flying_rocket',
  'scrap',
  'collection',
  'highlight',
  'arlam',
  'newsletter_profile',
] as const;

const iconMap = new Map<IconName, React.JSX.Element>([
  ['fire', <Fire key="fire" />],
  ['rocket', <Rocket key="rocket" />],
  ['heart_face', <HeartFace key="heart_face" />],
  ['slack', <Slack key="slack" />],
  ['verification', <Verification key="verification" />],
  ['think_face', <ThinkFace key="think_face" />],
  ['confetti', <Confetti key="confetti" />],
  ['cookie', <Cookie key="cookie" />],
  ['moon', <Moon key="moon" />],
  ['sun', <Sun key="sun" />],
  ['secret_face', <SecretFace key="secret_face" />],
  ['ok', <Ok key="ok" />],
  ['chrome', <Chrome key="chrome" />],
  ['search_face', <SearchFace key="search_face" />],
  ['menu_naver', <MenuNaver key="menu_naver" />],
  ['menu_samsung', <MenuSamsung key="menu_samsung" />],
  ['menu_chrome', <MenuChrome key="menu_chrome" />],
  ['menu_safari', <MenuSafari key="menu_safari" />],
  ['playful_face', <PlayfulFace key="playful_face" />],
  ['guide_heart', <GuideHeart key="guide_heart" />],
  [
    'newsletter_guide_icon',
    <NewsletterGuideIcon key="newsletter_guide_icon" />,
  ],
  ['smile_face', <SmileFace key="smile_face" />],
  ['celebration', <Celebration key="celebration" />],
  ['coffee', <Coffee key="coffee" />],
  ['honey', <Honey key="honey" />],
  ['sprout', <Sprout key="sprout" />],
  ['increase_triangle', <IncreaseTriangle key="increase_triangle" />],
  ['decrease_triangle', <DecreaseTriangle key="decrease_triangle" />],
  ['by', <By key="by" />],
  ['eye', <Eye key="eye" />],
  ['heart', <Heart key="heart" />],
  ['flying_rocket', <FlyingRocket key="flying_rocket" />],
  ['note', <Note key="note" />],
  ['scrap', <Scrap key="scrap" />],
  ['collection', <Collection key="collection" />],
  ['highlight', <Highlight key="highlight" />],
  ['arlam', <Arlam key="arlam" />],
  ['newsletter_profile', <NewsletterProfile key="newsletter_profile" />],
]);

export { iconMap };
